/**
 * Created by staffanrantzow on 22/04/16.
 */

import React from 'react';

export class PageTitle extends React.Component {

  constructor (props) {
    super(props);

    this.state = {
      title: ''
    };
  }

  componentDidMount () {
    setTimeout(this.updatePageTitle.bind(this), 1);
  }

  componentDidUpdate () {
    setTimeout(this.updatePageTitle.bind(this), 1);
  }

  updatePageTitle () {
    let selected = document.querySelectorAll('.side-menu .selected span');
    let pageTitle = '';
    let titles = [];

    if (window.innerWidth > 400) {
      for (let s of selected) {
        titles.push(s.textContent);
      }

      pageTitle = titles.join(' - ');
    } else {
      if (selected.length > 0) {
        pageTitle = selected[selected.length - 1].textContent;
      }
    }

    if (this.state.title !== pageTitle) {
      this.setState({
        title: pageTitle
      });
    }
  }

  render () {
    return (<span>{this.state.title}</span>);
  }

}

export default PageTitle;



/** WEBPACK FOOTER **
 ** ./src/components/left-page-section/side-menu/page-title.js
 **/